// Pure helpers for the Service History page. Kept free of React so the
// grouping/filter/subtotal rules are unit-testable on their own.

const MONTH_NAMES = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER",
];

export const STATUS_FILTERS = [
    "all", "approved", "pending", "no-show", "not-checked-in", "rejected",
];
export const SOURCE_FILTERS = ["all", "event", "independent"];
export const SOURCE_LABELS = {
    all: "All",
    event: "Event",
    independent: "Independent service",
};

// `no-show` and `not-checked-in` only ever apply to events and `rejected` only
// to independent work, so narrowing the source hides the tab that can never
// match.
const EVENT_ONLY = ["no-show", "not-checked-in"];

export const visibleStatusFilters = (source) => {
    if (source === "event") return STATUS_FILTERS.filter((f) => f !== "rejected");
    if (source === "independent") return STATUS_FILTERS.filter((f) => !EVENT_ONLY.includes(f));
    return STATUS_FILTERS;
};

const monthLabel = (isoDate) => {
    const [y, m] = isoDate.split("-");
    return `${MONTH_NAMES[Number(m) - 1]} ${y}`;
};

// `rows` arrives newest-first from buildServiceRows, so sections come out in
// order. `approvedHours` ignores the status filter and the search query --
// those are lookup aids -- but honors the source filter, which scopes the page.
export const buildMonthSections = (rows, { status = "all", source = "all", search = "" } = {}) => {
    const query = search.trim().toLowerCase();
    const sections = [];
    const byLabel = new Map();

    rows.forEach((row) => {
        const label = monthLabel(row.isoDate);
        let section = byLabel.get(label);
        if (!section) {
            section = { label, approvedHours: 0, items: [] };
            byLabel.set(label, section);
            sections.push(section);
        }

        const matchesSource = source === "all" || row.source === source;
        if (matchesSource && row.status === "approved" && row.hours !== null) {
            section.approvedHours += row.hours;
        }

        const matchesStatus = status === "all" || row.status === status;
        const matchesSearch = !query || row.name.toLowerCase().includes(query);
        if (matchesSource && matchesStatus && matchesSearch) section.items.push(row);
    });

    return sections
        .filter((section) => section.items.length > 0)
        .map((section) => ({
            ...section,
            approvedHours: Math.round(section.approvedHours * 10) / 10,
        }));
};
